"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailValidationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@framework/constants");
exports.emailValidationSchema = (0, yup_1.string)()
    .max(constants_1.emailMaxLength, "form.validations.tooLong")
    .required("form.validations.valueMissing")
    .email("form.validations.patternMismatch");
//# sourceMappingURL=email.js.map